import {create} from 'zustand'

// State Management for joyride Tutorials
const useJoyrideStore = create((set, get) => ({
	steps: [], // Initially, no steps are defined
	stepIndex: 0, // Current step index,
	run: false, // Controls if the Joyride should run

	// Update step index to a specific value
	updateStepIndex: (index) => set({ stepIndex: index }),

	startTour: () => set({ run: true }),
	resetTour: () => set({ run: false, stepIndex: 0 }),
	setSteps: (newSteps) => set({ steps: newSteps, stepIndex: 0 }),

	// Getter to check if the tour is running
	isTourRunning: () => get().run,
	getCurrentJoyrideStep: () => get().stepIndex
}))

export default useJoyrideStore